<h2 mat-dialog-title>Rule (ODRL)</h2>
<mat-dialog-content>
  <jsonld-code-display [content]="content" [isCopyButton]="true" [isEditable]="false"/>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>